"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridTable = "grid-table";
exports.gridHeader = "grid-header";
exports.textColumnHeader = "text-column-header";
exports.gridBody = "grid-body";
exports.gridHeaderSimple = "grid-header-simple";
exports.gridHeaderNoDivider = "grid-header-no-divider";
exports.gridBodySimple = "grid-body-simple";
exports.gridFooter = "grid-footer";
exports.pager = "pager";
exports.gridRow = "grid-row";
exports.menuCellMenu = "menu-cell-menu";
exports.gridRowAutoHeight = "grid-row-auto-height";
exports.gridRowSimple = "grid-row-simple";
exports.gridTotalsRow = "grid-totals-row";
exports.gridTotalsRowSimple = "grid-totals-row-simple";
exports.totalsCell = "totals-cell";
exports.gridRowSelectable = "grid-row-selectable";
exports.gridRowSelected = "grid-row-selected";
exports.gridRowExpanded = "grid-row-expanded";
exports.noDataGridRow = "no-data-grid-row";
exports.noDataGridRowSimple = "no-data-grid-row-simple";
exports.expandedRowContainer = "expanded-row-container";
exports.expandedRowContentContainer = "expanded-row-content-container";
exports.expandedRowContent = "expanded-row-content";
exports.expandedRowTopShadow = "expanded-row-top-shadow";
exports.expandedRowBottomShadow = "expanded-row-bottom-shadow";
exports.gridCell = "grid-cell";
exports.numeric = "numeric";
exports.gridIconCell = "grid-icon-cell";
exports.gridCheckboxCell = "grid-checkbox-cell";
exports.columnHeaderCentered = "column-header-centered";
exports.columnHeaderRight = "column-header-right";
exports.iconColumnHeader = "icon-column-header";
exports.menuCell = "menu-cell";
exports.menuCellContent = "menu-cell-content";
exports.gridHeaderSortHover = 'grid-header-sort-hover';
exports.gridHeaderIcon = 'grid-headericon';
